



















import { Component, Vue, Prop } from 'vue-property-decorator';

// This component is called LinkButton and not Link because Link is a reserved html tag
@Component({})
export default class LinkButton extends Vue {
  @Prop()
  public label!: string;

  @Prop({ default: '', required: true })
  public href!: string;

  @Prop({ default: true })
  public external!: boolean;

  @Prop({ default: 'underlined' })
  public variant!: 'underlined' | 'bold';

  public get hasPrefix(): boolean {
    return !!this.$slots.prefix;
  }
}
